<template>
    <div class="reveal" style="width:100%;">
        <div class="container" style="width:50%;text-align:center;">
            <div class="split-text title"><p>Conical Connection Implants: What Do the Pros Say?</p></div>
            <div class="split-text subtitle"><p>We recently asked several very experienced,world-renowned implant specialists to weigh in on the questions surrounding the benefits of the conical connection, and share their top tips for working with these types of implants. Our goal was to create a helpful guide of dos and don’ts that will help professionals optimize their use of these implant types.</p></div>        
        </div>

        <div class="xrImgCircleItems">
            <div style="--index:0" class="xrImgCircle"><div class="xrImg" style="background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Wael_Att.jpg')"></div></div>
            <div style="--index:1" class="xrImgCircle"><div class="xrImg" style="background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Nitzan_Bichacho.jpg')"></div></div>
            <div style="--index:2" class="xrImgCircle"><div class="xrImg" style="background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Tali_Chackartchi.jpg')"></div></div>
            <div style="--index:3" class="xrImgCircle"><div class="xrImg" style="background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Victor_Clavijo.jpg')"></div></div>
            <div style="--index:4" class="xrImgCircle"><div class="xrImg" style="background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Mirela_Feraru.jpg')"></div></div>
            <div style="--index:5" class="xrImgCircle"><div class="xrImg" style="background-image: url('https://www.mis-implants.com/upload/Education/MIS-Academy/Our-Speakers/Speakers/Pablo_Galindo.jpg')"></div></div>
        </div>

        <div class="xrBtn">
            <a href="/Products/MGUIDE" class="white_btn animation_up">
            <span class="title">Read More</span><i class="fal fa-chevron-right pl-s" ></i>
            </a>
        </div>
    </div>
</template>



<style lang="stylus">  
  .split-text
    margin auto
    color #fff
    width 100%
    //font-size 
    //line-height 26px
    &.title
      //font-size 50px
      //line-height 58px
      letter-spacing -2px
      padding-bottom 15px
  .xLine
    overflow hidden
    border solid 0px red    
  .xLineText
    border solid 0px red
    position relative 
    top 0px
    //letter-spacing -1px !important
    opacity 0
    //animation xSlideTextUp 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    //animation-fill-mode forwards
</style>

<style>
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    .reveal.active .xLineText
    {      
        animation-delay: calc(0.14s * var(--line_index)) !important;
        animation:xSlideTextUp 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        animation-fill-mode:forwards;        
    }
    .reveal.active .xrImgCircle
    {
        animation-delay: calc(1s + 0.1s * var(--index)) !important;
        animation: cirImgOpenBase 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        animation-fill-mode:forwards;        
    }
    .reveal.active .xrImgCircle .xrImg
    {
        animation-delay: calc(0.1s * var(--index)) !important;
        animation: cirImgOpen 3.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        animation-fill-mode:forwards;
    }    
    .reveal.active .animation_up
    {
        animation:xSlideBtnUp 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        animation-fill-mode:forwards;
        -webkit-animation-delay: 1.8s;
        animation-delay:1.8s;
    }
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/

  .split-text.subtitle .xLine .xLineText
  {
    font-weight: 300 !important;
  }
  .split-text.title .xLine .xLineText
  {
    font-weight: 600 !important;
  }
  .xrImgCircleItems
  {
    display: grid;
    justify-items: center;
    grid-template-columns: repeat(6, minmax(115px, 1fr));  
    padding-top:30px;clear:both;width:50%;margin:auto;
  }
  .xrImgCircle
  {
    opacity: 0;
    clip-path: circle(50px at center);
    position: relative;
    background-color:rgba(255,255,255,0.15);
    width: 120px;height: 120px;
  }

  .xrImgCircle .xrImg
  {
    opacity: 1;
    position: absolute;
    width: 120px;height: 120px;
    background-size: 115%;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center center;    
    clip-path: circle(40px at center);
    transition: all ease-in-out 0.3s;
  }
  .xrImgCircle:hover .xrImg
  {
    __clip-path: circle(35px at center);
  }
    .clip-circle {
    clip-path: circle(40px at center);
    /* OLD VALUE example: circle(245px, 140px, 50px); */
    /* Yep, even the new clip-path has deprecated stuff. */
    }


  @keyframes cirImgOpenBase {
    from {clip-path: circle(1px at center);opacity: 0;}  
    to {transform: circle(50px at center);opacity: 1;}
  }  
  @keyframes cirImgOpen {
    from {clip-path: circle(1px at center);opacity: 0;}  
    to {transform: circle(40px at center);opacity: 1;}
  }  
  @keyframes xSlideTextUp {
    from {transform: translateY(40px);opacity: 0;}  
    to {transform: translateY(0);opacity: 1;}
  }
  @keyframes xSlideBtnUp {
    from {transform: translateY(20px);opacity: 0;}  
    to {transform: translateY(0);opacity: 1;}
  }

  .animation_up{
    opacity:0;
  }
  .white_btn
  {
    opacity:0;
    cursor: pointer;
    position: relative;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    color: #fff !important;
    border: 1px solid #ddd;
    text-align: left;
    background-color:transparent;
    padding: 25px 25px;
    border-radius: 40px;
    height: 40px;
    font-size: 14px;
  }
  .white_btn span
  {
    line-height: 1;
    display: inline-block;
    vertical-align: middle;    
  }
  .xrBtn
  {
    padding-top:20px;color:#fff;width:50%;margin:auto;text-align:center;
  }
</style>




<script>
import { mapActions, mapState } from "vuex";
import { splitLines }         from "@/utils";

export default {
  name: "hpPros",
  mounted() {
    this.initText();
  },
  methods: {
    initText()
    {
      var splitBlocks = document.getElementsByClassName('split-text');
      for (var i = 0; i < splitBlocks.length; i++) {
        splitLines(splitBlocks[i]); 
      }
    },
  },
  computed: {
    ...mapState(["pageLayoutData", "locale", "dirtyHome"]),
  }
};
</script>

